<template>
  <v-app>
    <v-navigation-drawer dark app right temporary v-model="showNavDrawer">
      <v-list>
        <v-list-item v-for="(navlink,i) in navlinks" :key="i"
        :to="navlink.link">
          {{navlink.name}}
        </v-list-item>
      </v-list>
      <a href="https://facebook.com" target="_blank">
        <v-icon>
          mdi-facebook
        </v-icon>
      </a>

      <a href="https://facebook.com" target="_blank">
        <v-icon>
          mdi-instagram
        </v-icon>
      </a>

      <a href="https://facebook.com" target="_blank">
        <v-icon>
          mdi-twitter
        </v-icon>
      </a>

      <template v-slot:append>
        <div v-if="isAuthenticated" class="pa-2">
          <v-btn block outlined
          @click="logoutUser"
          >Kilépés</v-btn>
        </div>
        <div v-else class="pa-2">
          <v-btn block outlined
          to="/administration"
          >Adminisztráció</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app hide-on-scroll>
      <router-link tag="div" class="logo" to="/">
        <h1>MMM</h1>
      </router-link>
      <v-spacer></v-spacer>
      <div v-if="isAuthenticated" class="appbar-username">
        <v-icon class="accounticon">mdi-account</v-icon>
        <router-link to="/administration" tag="span">{{username}}</router-link>
        <v-icon @click="logoutUser" class="logouticon">mdi-logout</v-icon>
      </div>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        @click="showNavDrawer=!showNavDrawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-content>
      <v-container>

        <v-row v-if="$store.getters.loading" justify=center class="progress">
          <v-col cols="12" >
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>

        <transition name="fade" appear mode="out-in">
          <router-view v-if="!$store.getters.loading" dark></router-view>
        </transition>

      </v-container>
    </v-content>

    <Footer/>

  </v-app>
</template>

<script>
import axios from 'axios';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Footer,
  },
  data(){
    return{
      showNavDrawer: true,
      navlinks: [
        {name: 'Kezdőlap', link: '/'},
        {name: 'Támogass minket!', link: '/helpus'},
        {name: 'Fogadj örökbe', link: '/orokbefogadas'},
        {name: 'Híreink', link: '/hirek'},
        {name: 'Rólunk', link: '/rolunk'},
        {name: 'Kapcsolat', link: '/kapcsolat'},
        {name: 'Oldal-info', link: '/faq'},
        {name: 'DEMO', link: '/demo'},
      ]
    }
  },
  created(){
    this.$store.dispatch('setAnimals');
    this.$store.dispatch('tryAutoLogin');
  },
  mounted(){
    this.$store.dispatch('setAnimals');
  },
  computed:{
    isAuthenticated(){
      return this.$store.getters.isAuthenticated
    },
    username(){
      return this.$store.getters.username
    }
  },
  methods: {
    logoutUser(){
      this.$store.dispatch('logout')
    },
  },
};
</script>

<style lang="scss">
  @import './styles/global.scss';
  .theme--light.v-application{
    background: linear-gradient(left, rgba(238,196,135,.5) 0%,rgba(243,207,154,.5) 3%,rgba(248,216,162,.5) 6%,rgba(243,207,154,.5) 6%,rgba(243,207,154,.5) 9%,rgba(241,202,136,.5) 12%,rgba(243,207,154,.5) 15%,rgba(244,208,158,.5) 17%,rgba(243,207,154,.5) 19%,rgba(243,207,154,.5) 21%,rgba(250,221,176,.5) 23%,rgba(250,221,176,.5) 25%,rgba(243,207,154,.5) 27%,rgba(238,200,138,.5) 29%,rgba(243,207,154,.5) 29%,rgba(243,207,154,.5) 32%,rgba(243,207,154,.5) 34%,rgba(243,207,154,.5) 37%,rgba(250,221,176,.5) 40%,rgba(250,221,176,.5) 43%,rgba(243,207,154,.5) 43%,rgba(243,207,154,.5) 44%,rgba(243,207,154,.5) 47%,rgba(238,200,138,.5) 49%,rgba(243,207,154,.5) 52%,rgba(250,221,176,.5) 54%,rgba(244,208,158,.5) 56%,rgba(243,207,154,.5) 59%,rgba(244,208,158,.5) 61%,rgba(250,221,176,.5) 64%,rgba(243,207,154,.5) 64%,rgba(244,208,158,.5) 66%,rgba(243,207,154,.5) 69%,rgba(248,216,162,.5) 71%,rgba(243,207,154,.5) 74%,rgba(243,207,154,.5) 76%,rgba(243,207,154,.5) 77%,rgba(243,207,154,.5) 80%,rgba(250,221,176,.5) 81%,rgba(243,207,154,.5) 83%,rgba(250,221,176,.5) 83%,rgba(250,221,176,.5) 85%,rgba(243,207,154,.5) 87%,rgba(250,221,176,.5) 89%,rgba(250,221,176,.5) 91%,rgba(243,207,154,.5) 92%,rgba(248,216,162,.5) 96%,rgba(243,207,154,.5) 97%,rgba(243,207,154,.5) 97%,rgba(243,207,154,.5) 98%,rgba(243,207,154,.5) 100%),
linear-gradient(right, rgba(238,196,135,.3) 0%,rgba(243,207,154,.3) 3%,rgba(248,216,162,.3) 6%,rgba(243,207,154,.3) 6%,rgba(243,207,154,.3) 9%,rgba(241,202,136,.3) 12%,rgba(243,207,154,.3) 15%,rgba(244,208,158,.3) 17%,rgba(243,207,154,.3) 19%,rgba(243,207,154,.3) 21%,rgba(250,221,176,.3) 23%,rgba(250,221,176,.3) 25%,rgba(243,207,154,.3) 27%,rgba(238,200,138,.3) 29%,rgba(243,207,154,.3) 29%,rgba(243,207,154,.3) 32%,rgba(243,207,154,.3) 34%,rgba(243,207,154,.3) 37%,rgba(250,221,176,.3) 40%,rgba(250,221,176,.3) 43%,rgba(243,207,154,.3) 43%,rgba(243,207,154,.3) 44%,rgba(243,207,154,.3) 47%,rgba(238,200,138,.3) 49%,rgba(243,207,154,.3) 52%,rgba(250,221,176,.3) 54%,rgba(244,208,158,.3) 56%,rgba(243,207,154,.3) 59%,rgba(244,208,158,.3) 61%,rgba(250,221,176,.3) 64%,rgba(243,207,154,.3) 64%,rgba(244,208,158,.3) 66%,rgba(243,207,154,.3) 69%,rgba(248,216,162,.3) 71%,rgba(243,207,154,.3) 74%,rgba(243,207,154,.3) 76%,rgba(243,207,154,.3) 77%,rgba(243,207,154,.3) 80%,rgba(250,221,176,.3) 81%,rgba(243,207,154,.3) 83%,rgba(250,221,176,.3) 83%,rgba(250,221,176,.3) 85%,rgba(243,207,154,.3) 87%,rgba(250,221,176,.3) 89%,rgba(250,221,176,.3) 91%,rgba(243,207,154,.3) 92%,rgba(248,216,162,.3) 96%,rgba(243,207,154,.3) 97%,rgba(243,207,154,.3) 97%,rgba(243,207,154,.3) 98%,rgba(243,207,154,.3) 100%),
  linear-gradient(left, rgba(238,196,135,.3) 0%,rgba(243,207,154,.3) 3%,rgba(238,200,138,.3) 49%,rgba(243,207,154,.3) 52%,rgba(250,221,176,.3) 54%,rgba(244,208,158,.3) 56%,rgba(243,207,154,.2) 59%,rgba(244,208,158,.3) 61%,rgba(250,221,176,.3) 64%,rgba(243,207,154,.3) 64%,rgba(244,208,158,.3) 66%,rgba(243,207,154,.3) 69%,rgba(248,216,162,.3) 71%,rgba(243,207,154,.3) 74%,rgba(243,207,154,.3) 76%,rgba(243,207,154,.3) 77%,rgba(243,207,154,.3) 80%,rgba(250,221,176,.3) 81%,rgba(243,207,154,.3) 83%,rgba(250,221,176,.3) 83%,rgba(250,221,176,.3) 85%,rgba(243,207,154,.3) 87%,rgba(250,221,176,.3) 89%,rgba(250,221,176,.3) 91%,rgba(243,207,154,.3) 92%,rgba(248,216,162,.3) 96%,rgba(243,207,154,.3) 97%,rgba(243,207,154,.3) 97%,rgba(243,207,154,.3) 98%,rgba(243,207,154,.3) 100%) !important;
background-color:rgba(33, 22, 0, 1) !important;
background-size:500px 20px, 300px 20px, 20px 820px;
background-position:50% 50%, 70% 70%, 30% 30%;

  }
  .v-application,
  .v-toolbar__content{
    // max-width: 1500px;
    margin: 0 auto;
  }

  .theme--light.v-sheet.v-toolbar{
    background-color: transparent;
  }

  .logo h1{
    padding: 5px;
    font-size: 1.5rem;
    cursor: pointer;

    &:hover{
      color: $silver;
    }
  }

  .appbar-username span{
    cursor: pointer;
  }

  .logouticon:hover{
    cursor: pointer;
    color: red !important;
  }



  .v-navigation-drawer{
    background: url('./assets/navdrawer-cat.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .v-list-item--link.theme--dark{
      color: $silver;
    }

    .v-icon{
      margin-left: 10px;
    }
  }

  .progress{
    text-align: center;
    margin-top: 25vh;
  }
</style>
